<i18n lang="yaml" locale="en">
  field color: Field color
</i18n>

<i18n lang="yaml" locale="de">
  field color: Feldfarbe
</i18n>

<template>
  <div @click.capture="handleEdit">
    <locale-dropdown
      :value="activeLocale"
      :options="dropdownOptions"
      @input="updateLocale($event)"
      :background-color="fieldColor"
      :height="$parent.boxHeight"
      :width="$parent.boxWidth"
    />
  </div>
</template>

<script>
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'
import LocaleDropdown from '@/components/modules/LocaleDropdown'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'localeChanger',
  components: {
    LocaleDropdown
  },
  extends: BaseModule,
  customStore: translatable,
  props: {
    // eslint-disable-next-line
    _headlineorderBy: {
      input: 'heading',
      label: 'field color'
    },
    fieldColor: {
      type: String,
      default: '#000',
      input: 'color'
    }
  },
  methods: {
    updateLocale (locale) {
      return this.$root.$store.dispatch('setContentLocale', {
        locale: locale === this.$store.getters.defaultLocale ? '' : locale
      })
    },
    handleEdit (event) {
      if (this.$editMode) {
        this.$router.replace({ query: { edit: this.$store.getters.path } })
        event.stopPropagation()
      }
    }
  },
  computed: {
    dropdownOptions () {
      return [...this.$store.getters.locales, this.$store.getters.defaultLocale]
    },
    activeLocale () {
      return this.$root.$store.getters.contentLocale || this.$store.getters.defaultLocale
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  overflow: visible !important;
}
</style>
